// ./src/components/generic/IconSelector/eventIcons.ts
//
// Curated catalog of icons for events / venues / catering / music / games, grouped
// for the IconSelector picker. Pure data (no imports) so the icon-registry
// generator script can also read the flat name list.
//
// IMPORTANT: every name here must ALSO be listed in scripts/icons.config.ts
// (manualIcons) so the AppIcon registry bundles it — the generator can't import
// this file (it statically parses the config's literal array). Keep the two in
// sync; all names are Tabler icon names (PascalCase, no "Icon" prefix).

export interface EventIconGroup {
  /** i18n key suffix + default label for the group heading. */
  key: string;
  label: string;
  icons: string[];
}

export const EVENT_ICON_GROUPS: EventIconGroup[] = [
  {
    key: "popular",
    label: "Popular",
    icons: [
      "Star", "Heart", "Sparkles", "Gift", "Confetti", "Award", "Trophy",
      "Crown", "Flag", "Diamond", "Flower", "Balloon", "Rainbow", "Flame", "Bulb",
    ],
  },
  {
    key: "venue",
    label: "Venue & amenities",
    icons: [
      "Building", "BuildingCommunity", "BuildingCircus", "Home", "Tent",
      "Elevator", "Stairs", "Door", "Key", "Parking", "Car", "Wifi",
      "AirConditioning", "Snowflake", "Sun", "Moon", "Hanger", "Bath", "BadgeWc",
      "Pool", "Beach", "Whirl",
    ],
  },
  {
    key: "food",
    label: "Food & drink",
    icons: [
      "GlassFull", "Glass", "Beer", "Bottle", "Coffee", "Cup", "Pizza",
      "Salad", "Meat", "Cheese", "Cake", "IceCream", "ChefHat",
      "ToolsKitchen2", "Bread",
    ],
  },
  {
    key: "music",
    label: "Music & entertainment",
    icons: [
      "Music", "Microphone", "Microphone2", "Headphones", "GuitarPick",
      "Disc", "Vinyl", "Playlist", "Mask", "Movie", "DeviceTv", "Camera",
      "Video", "Photo",
    ],
  },
  {
    key: "games",
    label: "Games & activities",
    icons: [
      "DeviceGamepad", "DeviceGamepad2", "BallFootball", "BallBasketball",
      "Dice", "Dice5", "Chess", "Cards", "PlayCard", "Puzzle", "Target",
      "Bowling", "Run", "Swimming", "Yoga", "Massage",
    ],
  },
  {
    key: "schedule",
    label: "Schedule & tickets",
    icons: [
      "CalendarEvent", "CalendarTime", "Clock", "Hourglass", "MapPin", "Map",
      "Route", "Ticket", "Coins", "Businessplan", "PigMoney", "Discount", "Briefcase",
    ],
  },
  {
    key: "creative",
    label: "Learning & creative",
    icons: ["Books", "Book", "School", "Palette", "Brush"],
  },
  {
    key: "policy",
    label: "Policies & access",
    icons: [
      "Accessible", "Wheelchair", "Dog", "Cat", "Paw", "MoodKid", "MoodSmile",
      "Smoking", "SmokingNo", "Shield", "Lock", "LockOpen", "Users",
      "UserCheck", "AlertTriangle", "InfoCircle", "CircleCheck",
    ],
  },
];

/** Flat, de-duplicated list of every curated icon name. */
export const EVENT_ICON_NAMES: string[] = Array.from(
  new Set(EVENT_ICON_GROUPS.flatMap((g) => g.icons))
);
